import { Grid, IconButton, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import { useQuery } from "@apollo/client";
import { GET_WEBTOON_NAVIGATION_BY_PROGRAM_ID } from "../../../../../quries/webtoon";
import { Link } from "react-router-dom";

interface WebtoonPrevProps {
  id: any;
  parentId: any;
}
const useStyles = makeStyles((theme) => ({
  navPrev: {
    position: "fixed",
    left: "10rem",
    [theme.breakpoints.down("xs")]: {
      left: -8,
    },
  },
  arrow: {
    fontSize: 104,
    [theme.breakpoints.down("xs")]: {
      fontSize: 56,
    },
  },
}));
function WebtoonPrev({ id, parentId }: WebtoonPrevProps) {
  const classes = useStyles();

  const [prev, setPrev] = useState<any>(null);
  const { data, loading, error } = useQuery(
    GET_WEBTOON_NAVIGATION_BY_PROGRAM_ID,

    {
      fetchPolicy: "no-cache",

      variables: {
        where: {
          id_lt: id,
          web_toons_program: {
            id_in: parentId,
          },
        },
        limit: 1,
        sort: "id:DESC",
      },
    }
  );

  useEffect(() => {
    if (data) {
      setPrev(data.webToons[0]);
    }
    return () => {
      setPrev(null);
    };
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.webToons) {
    console.log(error);
  }
  if (prev) {
    return (
      <Grid className={classes.navPrev}>
        <IconButton
          component={Link}
          to={`/webtoon/view/${prev.id}`}
          aria-label="이전화 보기"
        >
          {prev ? <NavigateBeforeIcon className={classes.arrow} /> : null}
        </IconButton>
      </Grid>
    );
  } else {
    return <div></div>;
  }
}

export default WebtoonPrev;
